import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "uk-card-small uk-card-default uk-margin-top uk-text-small" }
const _hoisted_2 = { class: "uk-card-body" }
const _hoisted_3 = {
  key: 0,
  class: "uk-table uk-table-striped uk-table-small"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 0,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_10 = {
  key: 1,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_11 = ["value", "onInput"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = {
  key: 4,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = {
  key: 5,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 6,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = {
  key: 7,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 8,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { "uk-tooltip": "Remove container" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  colspan: "8",
  align: "center"
}
const _hoisted_31 = { class: "uk-table uk-width-1-1 clr-storm-6 uk-table-striped uk-table-hover uk-table-divider" }
const _hoisted_32 = { "uk-tooltip": "Remove freight content" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  colspan: "2",
  align: "left"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "uk-margin"
}
const _hoisted_37 = {
  colspan: "1",
  align: "left"
}
const _hoisted_38 = {
  key: 1,
  class: "uk-table uk-table-striped uk-table-small"
}
const _hoisted_39 = {
  key: 0,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_40 = {
  key: 1,
  class: "uk-padding-remove-left uk-padding-remove-right"
}
const _hoisted_41 = ["value", "onInput"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { "uk-tooltip": "Remove container" }
const _hoisted_54 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSelector = _resolveComponent("FilterSelector")!
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "uk-card-header" }, [
      _createElementVNode("h3", { class: "uk-card-title" }, "Containers")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isDropAndHook)
        ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _cache[2] || (_cache[2] = _createElementVNode("th", null, "Container Number", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("th", null, "Length", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, "Type", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Seal Number", -1)),
              (!_ctx.settingsOrderLtlEnabled)
                ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Cargo Pieces"))
                : _createCommentVNode("", true),
              (_ctx.isRailPickUp)
                ? (_openBlock(), _createElementBlock("th", _hoisted_5, "Pick-Up #"))
                : (_ctx.isRailDropOff)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Release #"))
                  : _createCommentVNode("", true),
              (!_ctx.settingsOrderLtlEnabled)
                ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Cargo Description"))
                : _createCommentVNode("", true),
              (!_ctx.settingsOrderLtlEnabled)
                ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Weight"))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.containers, (container, containerIdx) => {
              return (_openBlock(), _createElementBlock("tbody", { key: containerIdx }, [
                _createElementVNode("tr", null, [
                  (!container.isAdded)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(container.containerId), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "uk-input uk-form-small uk-form-width-small",
                          placeholder: "Container Num",
                          value: 
                  container.containerId && container.containerId.toUpperCase()
                ,
                          onInput: ($event: any) => (
                  container.containerId = $event.target.value.toUpperCase()
                )
                        }, null, 40, _hoisted_11)
                      ])),
                  _createElementVNode("td", null, [
                    (container.sizeType)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(container.sizeType), 1))
                      : (_openBlock(), _createBlock(_component_FilterSelector, {
                          key: 1,
                          modelValue: container.size,
                          "onUpdate:modelValue": ($event: any) => ((container.size) = $event),
                          options: _ctx.containerSizes,
                          class: "uk-form-width-small uk-padding-remove-left uk-padding-remove-right",
                          clearable: false,
                          showLabels: false
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  ]),
                  (container.sizeType)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(container.sizeType), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createVNode(_component_FilterSelector, {
                          modelValue: container.type,
                          "onUpdate:modelValue": ($event: any) => ((container.type) = $event),
                          clearable: false,
                          options: _ctx.containerTypesValues,
                          class: "uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                      ])),
                  _createElementVNode("td", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      placeholder: "Seal Number",
                      "onUpdate:modelValue": ($event: any) => ((container.sealNumber) = $event)
                    }, null, 8, _hoisted_16), [
                      [_vModelText, container.sealNumber]
                    ])
                  ]),
                  (!_ctx.settingsOrderLtlEnabled)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "uk-input uk-form-small uk-form-width-small",
                          placeholder: "Cargo Pieces",
                          "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].quantity) = $event)
                        }, null, 8, _hoisted_18), [
                          [_vModelText, container.freightContents[0].quantity]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isRailPickUp)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "uk-input uk-form-small uk-form-width-small",
                          "onUpdate:modelValue": ($event: any) => ((container.pickupNumber) = $event),
                          placeholder: "Pick-Up #"
                        }, null, 8, _hoisted_20), [
                          [_vModelText, container.pickupNumber]
                        ])
                      ]))
                    : (_ctx.isRailDropOff)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "uk-input uk-form-small uk-form-width-small",
                            "onUpdate:modelValue": ($event: any) => ((container.releaseNumber) = $event),
                            placeholder: "Release #"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, container.releaseNumber]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                  (!_ctx.settingsOrderLtlEnabled)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "uk-input uk-form-small uk-form-width-small",
                          "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].description) = $event),
                          placeholder: "Description"
                        }, null, 8, _hoisted_24), [
                          [_vModelText, container.freightContents[0].description]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.settingsOrderLtlEnabled)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "uk-input uk-form-small uk-form-width-small",
                          "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].weight) = $event),
                          placeholder: "Weight (lbs)"
                        }, null, 8, _hoisted_26), [
                          [_vModelText, container.freightContents[0].weight]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.removeContainer(containerIdx)),
                      "uk-icon": "minus-circle"
                    }, null, 8, _hoisted_28)
                  ])
                ]),
                (_ctx.settingsOrderLtlEnabled)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _createElementVNode("td", _hoisted_30, [
                        _createElementVNode("div", null, [
                          _createElementVNode("table", _hoisted_31, [
                            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                              _createElementVNode("th", null, "Qty"),
                              _createElementVNode("th", null, "Packing Type"),
                              _createElementVNode("th", null, "Is Hazmat"),
                              _createElementVNode("th", null, "Weight (lbs)"),
                              _createElementVNode("th", null, "Description"),
                              _createElementVNode("th", null, "NMFC #"),
                              _createElementVNode("th", null, "NMFC Class"),
                              _createElementVNode("th")
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(container.freightContents, (freightContent, freightContentIdx) => {
                                return (_openBlock(), _createElementBlock("tr", { key: freightContentIdx }, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.quantity,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.quantity) = $event),
                                      id: "Quantity"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.packingType,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.packingType) = $event),
                                      id: "PackingType"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      type: "checkbox",
                                      modelValue: freightContent.isHazmat,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.isHazmat) = $event),
                                      id: "IsHazmat"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.weight,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.weight) = $event),
                                      id: "Weight"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.description,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.description) = $event),
                                      id: "Description",
                                      type: "textarea"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.nmfcNumber,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.nmfcNumber) = $event),
                                      id: "NMFCNumber"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_InputField, {
                                      modelValue: freightContent.nmfcClass,
                                      "onUpdate:modelValue": ($event: any) => ((freightContent.nmfcClass) = $event),
                                      id: "nmfcClass"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_32, [
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (
                            _ctx.removeFreightContents(
                              containerIdx,
                              freightContentIdx,
                            )
                          ),
                                      "uk-icon": "icon: minus-circle; ratio: 1.5"
                                    }, null, 8, _hoisted_33)
                                  ])
                                ]))
                              }), 128)),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_34, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.addFreightContents(containerIdx)),
                                    class: "uk-button uk-button-secondary uk-width-3-6"
                                  }, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("span", { "uk-icon": "plus-circle" }, null, -1),
                                    _createTextVNode(" Freight Content ", -1)
                                  ]))], 8, _hoisted_35)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (!_ctx.isDropAndHook)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_37, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addContainer && _ctx.addContainer(...args))),
                        class: "uk-button uk-button-secondary uk-width-3-6"
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("span", { "uk-icon": "plus-circle" }, null, -1),
                        _createTextVNode(" Container ", -1)
                      ]))])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isDropAndHook)
        ? (_openBlock(), _createElementBlock("table", _hoisted_38, [
            _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
              _createElementVNode("th", null, "Load Type"),
              _createElementVNode("th", null, "Container Number"),
              _createElementVNode("th", null, "Length"),
              _createElementVNode("th", null, "Type"),
              _createElementVNode("th", null, "Seal Number"),
              _createElementVNode("th", null, "Cargo Pieces"),
              _createElementVNode("th", null, "Cargo Description"),
              _createElementVNode("th", null, "Weight")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.containers, (container, containerIdx) => {
              return (_openBlock(), _createElementBlock("tr", { key: containerIdx }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.strForContainerLoadType(container.loadType)), 1),
                (!container.isAdded)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(container.containerId), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_40, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "uk-input uk-form-small uk-form-width-small",
                        placeholder: "Container Num",
                        value: 
                container.containerId && container.containerId.toUpperCase()
              ,
                        onInput: ($event: any) => (container.containerId = $event.target.value.toUpperCase())
                      }, null, 40, _hoisted_41)
                    ])),
                _createElementVNode("td", null, [
                  (container.sizeType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(container.sizeType), 1))
                    : (_openBlock(), _createBlock(_component_FilterSelector, {
                        key: 1,
                        modelValue: container.size,
                        "onUpdate:modelValue": ($event: any) => ((container.size) = $event),
                        options: _ctx.containerSizes,
                        class: "uk-form-width-small uk-padding-remove-left uk-padding-remove-right",
                        clearable: false,
                        showLabels: false
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                ]),
                (container.sizeType)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(container.sizeType), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_44, [
                      _createVNode(_component_FilterSelector, {
                        modelValue: container.type,
                        "onUpdate:modelValue": ($event: any) => ((container.type) = $event),
                        clearable: false,
                        options: _ctx.containerTypesValues,
                        class: "uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                    ])),
                _createElementVNode("td", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "uk-input uk-form-small uk-form-width-small",
                    placeholder: "Seal Number",
                    "onUpdate:modelValue": ($event: any) => ((container.sealNumber) = $event)
                  }, null, 8, _hoisted_46), [
                    [_vModelText, container.sealNumber]
                  ])
                ]),
                _createElementVNode("td", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "uk-input uk-form-small uk-form-width-small",
                    placeholder: "Cargo Pieces",
                    "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].quantity) = $event)
                  }, null, 8, _hoisted_48), [
                    [_vModelText, container.freightContents[0].quantity]
                  ])
                ]),
                _createElementVNode("td", _hoisted_49, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "uk-input uk-form-small uk-form-width-small",
                    "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].description) = $event),
                    placeholder: "Description"
                  }, null, 8, _hoisted_50), [
                    [_vModelText, container.freightContents[0].description]
                  ])
                ]),
                _createElementVNode("td", _hoisted_51, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "uk-input uk-form-small uk-form-width-small",
                    "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].weight) = $event),
                    placeholder: "Weight (lbs)"
                  }, null, 8, _hoisted_52), [
                    [_vModelText, container.freightContents[0].weight]
                  ])
                ]),
                _createElementVNode("td", _hoisted_53, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.removeContainer(containerIdx)),
                    "uk-icon": "minus-circle"
                  }, null, 8, _hoisted_54)
                ])
              ]))
            }), 128)),
            (_ctx.orderData.containers.length === 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addDropHookContainer && _ctx.addDropHookContainer(...args))),
                  class: "uk-button uk-button-secondary"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("span", { "uk-icon": "plus-circle" }, null, -1),
                  _createTextVNode(" Container ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}